import React from 'react';

import { Container } from '@/ui';
import { Product } from '@/features/constructorProducts';
import { useScrollToTop } from '@/hooks';

export const ProductPage = () => {
  useScrollToTop([], { behavior: 'auto' });

  return (
    <Container $paddingBottom={48}>
      <Product />
    </Container>
  );
};
